import React from "react";
import Amount from "./Amount";

const QuoteCostBreakdown = React.memo(({ localQuote }) => {
    const quantity = Number(localQuote.quantity) || 1;
    const partSubtotal = Number(localQuote.amount) || 0;
    const servicesPerEach = localQuote.bend_count >= 1 ? Number(localQuote.per_bend_price) || 0 : 0;
    const servicesSubtotal = servicesPerEach * quantity;
    const grandTotal = partSubtotal + servicesSubtotal;
    const partEach = partSubtotal / quantity;
    const servicesEach = servicesPerEach;
    const hasServiceCost = servicesEach > 0 || servicesSubtotal > 0;

    return (
        <>
            <p className="mb-1 d-flex align-items-center justify-content-between gap-2 w-100">
                <span className="text-start flex-grow-1">Part cost:</span>
                <span className="d-flex align-items-center mb-0 text-end gap-1">
                    <Amount amount={partEach} />
                    <span className="mb-0">/each</span>
                </span>
            </p>
            <p className="mb-1 d-flex align-items-center justify-content-between gap-2 w-100">
                <span className="text-start flex-grow-1">Part Subtotal:</span>
                <span className="text-end"><Amount amount={partSubtotal} /></span>
            </p>
            {hasServiceCost ? (
                <>
                    <div
                        className="w-100 my-2 align-self-center"
                        style={{ borderTop: "1px solid rgba(0, 0, 0, 0.15)" }}
                    />
                    <p className="mb-1 d-flex align-items-center justify-content-between gap-2 w-100">
                        <span className="text-start flex-grow-1">Service cost:</span>
                        <span className="d-flex align-items-center mb-0 text-end gap-1">
                            <Amount amount={servicesEach} />
                            <span className="mb-0">/each</span>
                        </span>
                    </p>
                    <p className="mb-1 d-flex align-items-center justify-content-between gap-2 w-100">
                        <span className="text-start flex-grow-1">Service Subtotal:</span>
                        <span className="text-end"><Amount amount={servicesSubtotal} /></span>
                    </p>
                    <div
                        className="w-100 my-2 align-self-center"
                        style={{ borderTop: "1px solid rgba(0, 0, 0, 0.15)" }}
                    />
                </>
            ) : (
                <div
                    className="w-100 my-2 align-self-center"
                    style={{ borderTop: "1px solid rgba(0, 0, 0, 0.15)" }}
                />
            )}
            <p className="mb-1 d-flex align-items-center justify-content-between gap-2 w-100">
                <span className="text-start flex-grow-1">Part Total:</span>
                <span className="d-flex align-items-center text-end gap-2">
                    <strong className="quotes-price mb-0">
                        <Amount amount={grandTotal} />
                    </strong>
                </span>
            </p>
        </>
    );
}, (prev, next) =>
    prev.localQuote.quantity === next.localQuote.quantity &&
    prev.localQuote.discount === next.localQuote.discount &&
    prev.localQuote.amount === next.localQuote.amount &&
    prev.localQuote.bend_count === next.localQuote.bend_count &&
    prev.localQuote.per_bend_price === next.localQuote.per_bend_price
);

export default QuoteCostBreakdown;

